import { Box, Typography } from '@mui/material';

export function QueueUploadGridParam() {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Typography variant='h6' sx={{ color: '#9e9e9e' }}>
                Upload Grid
            </Typography>
        </Box>
    );
}
